s<template>
  <v-card class="personal-card mx-auto" height="100%">
    <v-img
        v-if="!$tenantInfo.profileColor"
        class="white--text"
        height="125px"
        :src="$tenantInfo.profileCover || '/img/default-profile-cover.jpg'"
      />
    <div v-else class="profile-color" :style="`background-color: ${$tenantInfo.profileColor}`"></div>
    <v-card-text class="text-center">
      <v-avatar size="124" class="avatar" color="white" @click="showProfilePicDialog = true">
        <v-img v-if="user.principal.member.profileUrl || $tenantInfo.placeholder" :src="user.principal.member.profileUrl || $tenantInfo.placeholder" class="mb-4" ></v-img>
        <v-gravatar v-else default-img="mp" :email="user.principal.member.contacts[0].emails[0].email" class="mb-4"/>
      </v-avatar>
      <h3 class="headline"> {{ user.principal.member.name }}</h3>
      <div v-if="showMrn" class="primary--text subheading font-weight-bold">{{memberName || 'Member'}} #<b>{{user.principal.member.mrn}}</b></div>
      <div v-if="stats && stats.current">
        <v-alert class="inner-alert" :value="isMonthInReview" icon="mdi-calendar-check" text dense type="info">
          <p>It's a new month and last month is in review. Your achieved status will be updated once the review has been finished.</p>
          <b v-if="previous">
            Last month you reached: Rank&nbsp;{{previous.current.rank}}
          </b>
        </v-alert>
        <p>
          Achieved Status:
          <v-btn x-small dark color="primary" class="body-2">
            Rank {{stats.current.recognizedRank}}
          </v-btn>
        </p>
      </div>
      <div v-if="user.principal.member.sponsor" class="mt-3">
        <b>{{sponsorName || 'Your Sponsor'}}:</b>
        <v-layout row align-center>
          <v-flex mx-2 class="text-right">
            <v-avatar>
              <v-img v-if="user.principal.member.sponsor.profileUrl || $tenantInfo.placeholder" :src="user.principal.member.sponsor.profileUrl || $tenantInfo.placeholder"></v-img>
            </v-avatar>
          </v-flex>
          <v-flex mx-2 class="text-left">
            <div>
              <b>{{user.principal.member.sponsor.displayName}} </b>
              <br/>
              <small>{{user.principal.member.sponsor.contacts[0].emails[0].email}}</small>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-card-text>
    <v-divider class="mb-3"></v-divider>
    <div class="text-center pa-2">
      <h3 class="mb-4">Your Personal Link</h3>
      <MyLink />
    </div>
    <v-divider class="mb-3"></v-divider>
    <div class="text-center pa-2">
      <h3 class="mb-4">Profile Settings</h3>
      <PrivateProfile />
    </div>
    <v-divider class="mb-3"></v-divider>
    <slot name="footer"></slot>
    <FileUpload @dialogClosed="uploadDialogClosed" :shouldShow="showProfilePicDialog" @profile="makeProfilePic" :isProfilePic="true" />
  </v-card>
</template>

<script>
import DashCard from '@/components/DashboardCard.vue'
import MyLink from '@/components/MyLink.vue'
import PrivateProfile from '@/components/PrivateProfile.vue'
import FileUpload from '@/components/FileUpload.vue'
import { getAsset } from '@/utils/AssetService'
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex'
import { UserMutations, UserActions } from '@/stores/UserStore'
import { Mutations } from '@/store'

export default {
  name: 'PersonalCard',
  components: {
    MyLink,
    DashCard,
    FileUpload,
    PrivateProfile
  },
  props: {
    memberName: String,
    sponsorName: String,
    showMrn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showProfilePicDialog: false
    }
  },
  async mounted() {},
  watch: {
    '$apollo.loading'(newVal) {
      this.setLoading(newVal)
    }
  },
  apollo: {},
  methods: {
    uploadDialogClosed(val) {
      this.showProfilePicDialog = val
    },
    formatTimeSince(time) {
      if (time === 'a') {
        return 1
      }
      return time
    },
    async makeProfilePic(asset) {
      const profileUrl = getAsset(asset.id)
      await this.saveProfile({ memberId: this.user.principal.member.id, profileUrl })
      this.showProfilePicDialog = false
    },
    ...mapActions([
      UserActions.SAVE_PROFILE
    ]),
    ...mapMutations([
      UserMutations.MEMBER_QUERY,
      Mutations.SET_GATE,
      Mutations.SET_LOADING
    ])
  },
  computed: {
    ...mapState({
      user: state => state.user,
      stats: state => state.comp.currentPeriod,
      previous: state => state.comp.previousPeriod
    }),
    ...mapGetters(['contactId', 'memberId', 'slug', 'isMonthInReview']),
    isFounder() {
      return this.$moment(this.user.principal.member.joinedOn).isBefore('2020-03-01')
    }
  }
}
</script>

<style>
.profile-color {
  height: 125px;
  width: 100%;
}
.personal-card {
  width: 100%;
}
.personal-card .avatar {
  position: relative;
  top: -62px;
  margin-bottom: -62px;
  padding-top: 16px;
}
.personal-card .avatar .v-responsive,
.personal-card .avatar img {
  box-shadow: 0px -10px 30px -4px black;
  border: 3px solid white;
}

.personal-card .avatar::after{
  content: 'camera_alt';
  font-family: 'Material Icons';
  font-size: 78px;
  display: none;
  position: absolute;
  top: 0px;
  right: 2px;
  bottom: 2px;
  left: 2px;
  background-color: rgba(255,255,255,0.5);
  border-radius: 100%;
  cursor: pointer;
  line-height: 124px;
}
.personal-card .avatar:hover::after{
  display: block;
}
</style>
